<template>
  <div v-if="about">
    <h3 class="mb-5">Corporate Investment Messaging</h3>
    <div class="h4 mb-5">顯示於AboutUs頁面</div>
    <div>
      <!-- Title -->
      <label class="form-item d-flex py-5">
        <h4 class="w-180px">Title</h4>
        <div class="flex-grow-1 flex-basis-0">
          {{ about.corporate_title }}
        </div>
      </label>
      <!-- Content -->
      <label class="form-item d-flex py-5">
        <h4 class="w-180px">SubTitle</h4>
        <div class="flex-grow-1 flex-basis-0">
          {{ about.corporate_subtitle }}
        </div>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    about: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style></style>
